import { Reducer } from 'redux';

import { IRolesState } from 'types/roles.types';
import * as authConstants from 'redux/constants/auth.constants';
import * as constants from 'redux/constants/roles.constants';

export const defaultState: IRolesState = {
  count: 0,
  items: [],
  loading: false,
  permissions: [],
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'name',
    sortType: 'asc',
  },
};

const rolesReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.ROLES_ON_DELETE_REQUESTED:
    case constants.ROLES_ON_GET_ALL_REQUESTED:
    case constants.ROLES_ON_GET_FORM_REQUESTED:
    case constants.ROLES_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.ROLES_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.ROLES_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.ROLES_ON_GET_FORM_SUCCEEDED:
      return {
        ...state,
        loading: false,
        permissions: data.permissions,
      };
    case constants.ROLES_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.ROLES_ON_DELETE_SUCCEEDED:
    case constants.ROLES_ON_SAVE_SUCCEEDED:
    case constants.ROLES_ON_DELETE_FAILED:
    case constants.ROLES_ON_GET_ALL_FAILED:
    case constants.ROLES_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.ROLES_ON_GET_FORM_FAILED:
      return {
        ...state,
        loading: false,
        permissions: [],
      };
    case constants.ROLES_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default rolesReducer;
